import React, { memo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import styles from './styles.module.scss';

const Index = memo((props) => {

  const dispatch = useDispatch();
  const { handleNewsDetail } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const localesReducer = useSelector(({localesReducer}) => localesReducer.i18n);
  const { value: scrollNumReducer, cshVal } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  const { title } = props.config;

  const handleShow = () => {
    props.config.handleEvent();
  }

  return (
      <div className={normal()} onClick={handleShow}>
        <span className="ptTitle">{title}</span>
        <div className='icon'>
          <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2831 9.2168L15.5 4.99993L11.2831 0.783063" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 5L1 5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
  );
});
export default Index;
